import Router from 'vue-router'
import Vue from 'vue'
import routes from "./routers";
import store from '@/store'
import "../libs/flexible.js";
import { setToken, getToken, canTurnTo, setTitle,setBase64Token,getBase64Token,localRead} from "../libs/util";
import config from '@/config'
import echarts from 'echarts';
const {homeName} = config
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this,location,onResolve,onReject)
  return originalPush.call(this,location).catch(err=>err)
}
Vue.use(Router)
Vue.prototype.$echarts = echarts;

const router = new Router({
  routes,
  mode: 'history',
  base:'/broad/'
})
const LOGIN_PAGE_NAME = 'login'
const turnTo = (to, access, next) => {
  if(canTurnTo(to.name, access, routes)) next()
  else next({replace: true, name:'error_401'})
  //不需要判断权限
  //next()
}
router.beforeEach((to,from,next)=>{
  //iView.LoadingBar.start()
  const token = getToken();
  if (!token && to.name !== LOGIN_PAGE_NAME){
    next({
      name: LOGIN_PAGE_NAME
    })
  }else if (!token && to.name === LOGIN_PAGE_NAME) {
    next()
  }else if (token && to.name === LOGIN_PAGE_NAME) {
    var homeName = localRead('homeName');
    if(homeName === '' || homeName === undefined){
      homeName = 'control';
    }
    next({
      name: homeName
    });
  }else if (to.name === 'logout') {
    next()
  } else {
    if(to.name == 'alarm_split_screen'){
      next()
    }else {
      turnTo(to, store.state.user.access, next);
    }
  }
})
router.afterEach(to => {
  //去除动态标题
  //setTitle(to,router.app)
  //iView.LoadingBar.finish()
  window.scrollTo(0,0)
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js